module.exports = __webpack_public_path__ + "static/media/logo.c462cd94.png";